import brand from '@/branding'

export function displayCurrencyLabel(currency) {
  if (!currency) return 'RMB'
  return currency === 'CNY' ? 'RMB' : currency
}

export function decimalSeparator() {
  return brand.id === 'mt' ? ',' : '.'
}

export function formatPrice(value) {
  const amount = Number(value || 0).toFixed(2)
  return amount.replace('.', decimalSeparator())
}
